import clsx from "clsx";

export function SupportersDescription() {
  return (
    <aside className={clsx("border-b", "border-b-gray-200", "pb-8")}>
      <div className="space-y-4">
        <h2 className={clsx("text-xl", "leading-normal", "font-bold")}>おおかまサポーターとは</h2>
        <p>
          万代島多目的広場（おおかま）の活性化を目的として、自身のSNSでの告知やイベントへの参加を通して、認知拡大、盛り上げの一翼を担うメンバーです。
        </p>
      </div>
    </aside>
  );
}
